import { useState } from 'react';
import { PlatformBadgeElement } from './styles';

const PlatformBadge = ({ platformEnvironment }: $TSFixMe) => {
    const [visible, toggle] = useState(true);

    if (!visible) {
        return null;
    }

    const hide = () => toggle(false);

    return <PlatformBadgeElement onClick={hide}>{platformEnvironment}</PlatformBadgeElement>;
};

export default PlatformBadge;
